import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

type CardAccent = "red" | "default";

function ILT20Promo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const currencyRate = (brandId == 61) ? "USD 1" : (brandId == 46 || brandId == 47) ? "50 INR" : 'INR 50';

    return (
        <>
            <InformationWrapper>
                <Container>
                    <TopBanner>
                        <BannerText>
                            {(brandId == 31 || brandId == 32 || brandId == 61) && <><span className="highlight-blue">Yolo247</span> is the Front of Jersey Sponsor for the <span className="red">Desert Vipers</span> in ILT20. To celebrate the partnership, Yolo247 brings you the WinShield — a daily safety cover on your first losing Exchange bet.</>}
                            {(brandId == 33) && <>This <span className="red">ILT20</span> season, <span className="red">i</span>W247 adds a safety layer to your play. Your first losing Exchange bet each day is returned 100%.</>}
                            {(brandId == 39 || brandId == 40) && <>ILT20 is heating up — don't miss the action. FOMO<span className="highlight-orange">7</span> gives you a 100% PlaySafe Boost every match day. Your first losing Exchange bet gets fully covered.</>}
                        </BannerText>
                        <div className='staticImg'>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromoCricOneImg}`}
                                alt="How to Join"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </div>
                    </TopBanner>

                    <SectionTitle>
                        {(brandId == 31 || brandId == 32 || brandId == 61) && <>How WinShield Work?</>}
                        {(brandId == 33 || brandId == 39 || brandId == 40) && <>How It Works?</>}
                    </SectionTitle>

                    <Row>
                        <Card>
                            <CardText>
                                {(brandId == 31 || brandId == 32 || brandId == 61) && <>Go To Exchange On <span className="blue">Yolo247</span></>}
                                {(brandId == 33) && <>Go To Exchange On <span className="red">i</span>W247</>}
                                {(brandId == 39 || brandId == 40) && <>Open FOMO<span className="highlight-orange">7</span> Exchange</>}
                            </CardText>
                            <div className='staticImg2'>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromoCricTwoImg}`}
                                    alt="Cricket One"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                            </div>
                        </Card>

                        {(brandId == 33) ? <Card>
                            <CardText>
                                Place Your Bets On <span className="red">ILT20</span> <br /> Matches
                            </CardText>
                            <div className='staticImg3'>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromosheildImg}`}
                                    alt="Sheild Img"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                            </div>
                        </Card> :
                        <Card $accent="red">
                            <CardText>
                                Place Your Bets On <span className="red">ILT20</span> <br /> Matches
                            </CardText>
                            <div className='staticImg3'>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromosheildImg}`}
                                    alt="Sheild Img"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                            </div>
                        </Card>}
                    </Row>

                    <MiddleCard>
                        <MiddleText>
                            {(brandId == 31 || brandId == 32 || brandId == 61) && <>If Your First Exchange Bet Of The Day Loses,<br /> Yolo247 Returns The Full Stake The Next Day.</>}
                            {(brandId == 33) && <>If your first Exchange bet doesn't win, <br />receive 100% of your stake the next day</>}
                            {(brandId == 39 || brandId == 40) && <>If your first Exchange bet loses, FOMO<span className="highlight-orange">7</span> <br />returns 100% of your stake the next day</>}
                        </MiddleText>
                        <div className='staticImg4'>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromoTrophyImg}`}
                                alt="Trophy Img"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </div>
                    </MiddleCard>

                    <TermsSection>
                        <TermsTitle>Terms &amp; Conditions</TermsTitle>
                        <TermsList>
                            <li>Offer Valid Once Per Day.</li>
                            <li>Minimum Qualifying Bet: <strong>{currencyRate}</strong> On ILT20 Matches Only.</li>
                            {(brandId == 31 || brandId == 32 || brandId == 61) ? <li><strong>Offer Applies Only On Exchange Bets.</strong></li> :
                                (brandId == 33) ? <li><strong>Valid only on Exchange bets.</strong></li> : 
                                    (brandId == 39 || brandId == 40) ? <li><strong>Exchange bets Only.</strong></li> : <></>}
                            {(brandId == 31 || brandId == 32 || brandId == 33 || brandId == 61) ? <><li>Valid From <strong>2nd December 2025 To 4th January 2026.</strong></li></> :
                                (brandId == 39 || brandId == 40) ? <><li>Offer Valid from <strong>2nd December 2025 to 4th January 2026.</strong></li></> : <></>}
                            <li>Maximum Daily Return: <strong>{currencyRate}.</strong></li>
                            <li>Terms And Conditions Apply.</li>
                        </TermsList>
                    </TermsSection>
                </Container>

            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(ILT20Promo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 4rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.iLT20PromoMainInnerBg")});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    color: #fff;
    text-transform: capitalize;

    .staticImg {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: -34px;
        z-index: 9;

        img {
            width: 175px;
            height: 208px;
            max-width: 100%;
        }
    }

    .staticImg2 {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: 0;
        z-index: 9;

        img {
            width: 91px;
            height: 146px;
            max-width: 100%;
        }
    }

    .staticImg3 {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: 0;
        z-index: 9;

        img {
            width: 149px;
            height: 146px;
            max-width: 100%;
        }
    }

    .staticImg4 {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: 0;
        z-index: 9;

        img {
            width: 142px;
            height: 147px;
            max-width: 100%;
        }
    }

    span.highlight-blue {
        color: #0f83ff;
        font-weight: 600;
    }

    span.highlight-orange {
        color: #F90202;
        font-weight: 600;
    }

    span.highlight-orange {
        color: #FF7D49;
        font-weight: 600;
    }

    span.blue {
        color: #3b82f6;
    }
    span.red {
        color: #DE0000;
    }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1100px;
`;

const TopBanner = styled.div`
    height: 133px;
    padding: 2.5rem;
    display: flex;
    align-items: center;
    position: relative;
    /* overflow: hidden; */
    box-shadow: ${theme('palette.ILT20PromoTopBannerBShadow')};
    margin-bottom: 48px;
    border-radius: 19px;
    border: 1px solid #575757;
    background: ${theme('palette.ILT20PromoTopBannerBGColor')};

  &::after {
    content: "";
    position: absolute;
    inset: auto 40px -3px 40px;
    height: 4px;
    border-radius: 40px;
    background: ${theme('palette.ILT20PromoTopBannerAftrBColor')};
    filter: blur(0.6px);
    box-shadow: ${theme('palette.ILT20PromoTopBannerAftrBShadow')};
  }
`;

const BannerText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  max-width: 700px;
  font-weight: bold;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 18px;
  margin: 12px 0 52px;
  color: #FFF;
  text-transform: capitalize;
  font-weight: 700;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
  margin-bottom: 60px;
`;

const Card = styled.div<{ $accent?: CardAccent }>`
    height: 133px;
    position: relative;
    padding: 2.5rem;
    border-radius: 19px;
    border: 1px solid #575757;
    background: ${theme('palette.ILT20PromoTopBannerBGColor')};
    box-shadow: ${theme('palette.ILT20PromoTopBannerBShadow')};
    display: flex;
    align-items: center;
    justify-content: space-between;

  &::after {
    content: "";
    position: absolute;
    inset: auto 28px -3px 28px;
    height: 4px;
    border-radius: 40px;
    background: ${({ $accent }) =>
        $accent === "red"
            ? "#F00"
            : "#FFF"};
    box-shadow: ${({ $accent }) =>
        $accent === "red"
            ? "0px 0px 14px 0px #F00"
            : "0px 0px 14px 0px #fff"};
  }
`;

const CardText = styled.div`
  font-size: 14px;
  font-weight: bold;
  max-width: 70%;
`;

const MiddleCard = styled(Card)`
  margin: 0 auto 40px;
  max-width: 720px;

  &::after {
    background: ${theme('palette.ILT20PromoMiddleCardBGColor')};
  }
`;

const MiddleText = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.7;
`;

const TermsSection = styled.section`
  text-align: center;
`;

const TermsTitle = styled.h3`
  font-size: 22px;
  color: #FC0;
  margin-bottom: 20px;
`;

const TermsList = styled.ol`
  margin: 0 auto;
  padding-left: 22px;
  text-align: left;
  max-width: 640px;
  font-size: 14px;
  line-height: 1.8;
  color: #d5d7e5;

  strong {
    font-weight: 700;
  }
`;